import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  Button,
  Grid,
  TextField,
} from '@material-ui/core';
import * as yup from 'yup';
import {Formik} from 'formik';
import {createAdditionalFeaturesApi, editAdditionalFeaturesApi} from 'api/subscription';


const FeaturesForm = ({feature, setFeature}) => {
  const dispatch = useDispatch();
  const {additionalFeatures} = useSelector((state) => state.subscription);
  const additionalFeaturesSortOrders = additionalFeatures.reduce((orders, el) => {
    if (el.order !== feature?.order) {
      return [...orders, el.order];
    }

    return orders;
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          _id: feature?._id || '',
          label: feature?.label || '',
          description: feature?.description || '',
          priceOneTime: feature?.priceOneTime || '',
          priceMonthly: feature?.priceMonthly || '',
          order: feature?.order || 0,
        }}
        onSubmit={async (values) => {
          const feature = {
            label: values.label,
            order: values.order,
            description: values.description,
            priceOneTime: values.priceOneTime,
            priceMonthly: values.priceMonthly
          };

          if (values._id) {
            await editAdditionalFeaturesApi({dispatch, featureId: values._id, feature});
          } else {
            await createAdditionalFeaturesApi({dispatch, feature});
          }

          setFeature(null);
        }}
        validationSchema={
          yup.object({
            description: yup
              .string(),
            label: yup
              .string()
              .required('Field is required'),
            priceMonthly: yup
              .number()
              .typeError('Price value must be a number')
              .min(0, 'Value cannot go lower than 0'),
            order: yup
              .number()
              .notOneOf(additionalFeaturesSortOrders, 'Sort order already specified')
              .typeError('Order value must be a number')
              .min(0, 'Value cannot go lower than 0'),
            priceOneTime: yup
              .number()
              .typeError('Price value must be a number')
              .min(0, 'Value cannot go lower than 0'),
          })
        }
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit
        }) => (
          <form autoComplete="off" className="p-8" onSubmit={handleSubmit}>
            <Grid container spacing={3} className="p-4">
              <Grid item xs={12} sm={12} md={12}>
                <TextField
                  required
                  className="w-full"
                  label="Feature label"
                  name="label"
                  variant="outlined"
                  value={values.label}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.label && Boolean(errors.label)}
                  helperText={touched.label && errors.label}
                />
                <TextField
                  required
                  className="w-full mt-10"
                  label="One time price"
                  name="priceOneTime"
                  variant="outlined"
                  value={values.priceOneTime}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.priceOneTime && Boolean(errors.priceOneTime)}
                  helperText={touched.priceOneTime && errors.priceOneTime}
                />
                <TextField
                  required
                  className="w-full mt-10"
                  label="Monthly Price"
                  name="priceMonthly"
                  variant="outlined"
                  value={values.priceMonthly}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.priceMonthly && Boolean(errors.priceMonthly)}
                  helperText={touched.priceMonthly && errors.priceMonthly}
                />
                <TextField
                  required
                  className="w-full mt-10"
                  label="Order"
                  name="order"
                  variant="outlined"
                  value={values.order}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.order && Boolean(errors.order)}
                  helperText={touched.order && errors.order}
                />
                <TextField
                  multiline
                  className="w-full mt-10"
                  label="Feature description"
                  name="description"
                  variant="outlined"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.description && Boolean(errors.description)}
                  helperText={touched.description && errors.description}
                />
                <div className="flex items-center justify-end mt-8">
                  <Button
                    variant="contained"
                    onClick={() => setFeature(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="mx-10"
                    type="submit"
                  >
                    Submit
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  );
};

export default FeaturesForm;
